'use strict';

var _objectSpread = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode;

var Bucket = require('hamt-sharding/src/bucket');

var DirSharded = require('ipfs-unixfs-importer/src/dir-sharded');

var log = require('debug')('ipfs:mfs:core:utils:hamt-utils');

var UnixFS = require('ipfs-unixfs');

var mc = require('multicodec');

var mh = require('multihashes');

var last = require('it-last');

var updateHamtDirectory = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, links, bucket, options) {
    var data, node, dir, hashAlg, parent, cid;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // update parent with new bit field
            data = Buffer.from(bucket._children.bitField().reverse());
            node = UnixFS.unmarshal(options.parent.Data);
            dir = new UnixFS({
              type: 'hamt-sharded-directory',
              data: data,
              fanout: bucket.tableSize(),
              hashType: DirSharded.hashFn.code,
              mode: node.mode,
              mtime: node.mtime
            });
            hashAlg = mh.names[options.hashAlg];
            parent = new DAGNode(dir.marshal(), links);
            _context.next = 7;
            return context.ipld.put(parent, mc.DAG_PB, {
              cidVersion: options.cidVersion,
              hashAlg: hashAlg,
              onlyHash: !options.flush
            });

          case 7:
            cid = _context.sent;
            return _context.abrupt("return", {
              node: parent,
              cid: cid,
              size: parent.size
            });

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateHamtDirectory(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var recreateHamtLevel = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(links, rootBucket, parentBucket, positionAtParent) {
    var bucket;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // recreate this level of the HAMT
            bucket = new Bucket({
              hashFn: DirSharded.hashFn,
              hash: parentBucket ? parentBucket._options.hash : undefined
            }, parentBucket, positionAtParent);

            if (parentBucket) {
              parentBucket._putObjectAt(positionAtParent, bucket);
            }

            _context2.next = 4;
            return addLinksToHamtBucket(links, bucket, rootBucket);

          case 4:
            return _context2.abrupt("return", bucket);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function recreateHamtLevel(_x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

var addLinksToHamtBucket = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(links, bucket, rootBucket) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Promise.all(links.map(function (link) {
              if (link.Name.length === 2) {
                var pos = parseInt(link.Name, 16);

                bucket._putObjectAt(pos, new Bucket({
                  hashFn: DirSharded.hashFn
                }, bucket, pos));

                return Promise.resolve();
              }

              return (rootBucket || bucket).put(link.Name.substring(2), {
                size: link.Tsize,
                cid: link.Hash
              });
            }));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function addLinksToHamtBucket(_x9, _x10, _x11) {
    return _ref3.apply(this, arguments);
  };
}();

var toPrefix = function toPrefix(position) {
  return position.toString('16').toUpperCase().padStart(2, '0').substring(0, 2);
};

var generatePath = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context, fileName, rootNode) {
    var rootBucket, position, path, currentBucket, _loop, i, _ret;

    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return recreateHamtLevel(rootNode.Links, null, null, null);

          case 2:
            rootBucket = _context5.sent;
            _context5.next = 5;
            return rootBucket._findNewBucketAndPos(fileName);

          case 5:
            position = _context5.sent;
            // the path to the root bucket
            path = [{
              bucket: position.bucket,
              prefix: toPrefix(position.pos)
            }];
            currentBucket = position.bucket;

            while (currentBucket !== rootBucket) {
              path.push({
                bucket: currentBucket,
                prefix: toPrefix(currentBucket._posAtParent)
              });
              currentBucket = currentBucket._parent;
            }

            path.reverse();
            path[0].node = rootNode; // load DAGNode for each path segment

            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
              var segment, link, node, _position, nextSegment;

              return _regeneratorRuntime.wrap(function _loop$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      segment = path[i]; // find prefix in links

                      link = segment.node.Links.filter(function (link) {
                        return link.Name.substring(0, 2) === segment.prefix;
                      }).pop(); // entry was not in shard

                      if (link) {
                        _context4.next = 5;
                        break;
                      }

                      // reached bottom of tree, file will be added to the current bucket
                      log("Link ".concat(segment.prefix).concat(fileName, " will be added")); // return path

                      return _context4.abrupt("return", "continue");

                    case 5:
                      if (!(link.Name === "".concat(segment.prefix).concat(fileName))) {
                        _context4.next = 8;
                        break;
                      }

                      log("Link ".concat(segment.prefix).concat(fileName, " will be replaced")); // file already existed, file will be added to the current bucket
                      // return path

                      return _context4.abrupt("return", "continue");

                    case 8:
                      // found subshard
                      log("Found subshard ".concat(segment.prefix));
                      _context4.next = 11;
                      return context.ipld.get(link.Hash);

                    case 11:
                      node = _context4.sent;

                      if (path[i + 1]) {
                        _context4.next = 21;
                        break;
                      }

                      log("Loaded new subshard ".concat(segment.prefix));
                      _context4.next = 16;
                      return recreateHamtLevel(node.Links, rootBucket, segment.bucket, parseInt(segment.prefix, 16));

                    case 16:
                      _context4.next = 18;
                      return rootBucket._findNewBucketAndPos(fileName);

                    case 18:
                      _position = _context4.sent;
                      // i--
                      path.push({
                        bucket: _position.bucket,
                        prefix: toPrefix(_position.pos),
                        node: node
                      });
                      return _context4.abrupt("return", "continue");

                    case 21:
                      nextSegment = path[i + 1]; // add intermediate links to bucket

                      _context4.next = 24;
                      return addLinksToHamtBucket(node.Links, nextSegment.bucket, rootBucket);

                    case 24:
                      nextSegment.node = node;

                    case 25:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _loop);
            });
            i = 0;

          case 13:
            if (!(i < path.length)) {
              _context5.next = 21;
              break;
            }

            return _context5.delegateYield(_loop(i), "t0", 15);

          case 15:
            _ret = _context5.t0;

            if (!(_ret === "continue")) {
              _context5.next = 18;
              break;
            }

            return _context5.abrupt("continue", 18);

          case 18:
            i++;
            _context5.next = 13;
            break;

          case 21:
            _context5.next = 23;
            return rootBucket.put(fileName, true);

          case 23:
            path.reverse();
            return _context5.abrupt("return", {
              rootBucket: rootBucket,
              path: path
            });

          case 25:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4);
  }));

  return function generatePath(_x12, _x13, _x14) {
    return _ref4.apply(this, arguments);
  };
}();

var createShard = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(context, contents, options) {
    var shard, i;
    return _regeneratorRuntime.wrap(function _callee5$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            shard = new DirSharded({
              root: true,
              dir: true,
              parent: null,
              parentKey: null,
              path: '',
              dirty: true,
              flat: false,
              mtime: options.mtime,
              mode: options.mode
            }, _objectSpread(_objectSpread({}, options), {}, {
              codec: 'dag-pb'
            }));
            i = 0;

          case 2:
            if (!(i < contents.length)) {
              _context6.next = 8;
              break;
            }

            _context6.next = 5;
            return shard._bucket.put(contents[i].name, {
              size: contents[i].size,
              cid: contents[i].cid
            });

          case 5:
            i++;
            _context6.next = 2;
            break;

          case 8:
            return _context6.abrupt("return", last(shard.flush('', context.block, null)));

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee5);
  }));

  return function createShard(_x15, _x16, _x17) {
    return _ref5.apply(this, arguments);
  };
}();

module.exports = {
  generatePath: generatePath,
  updateHamtDirectory: updateHamtDirectory,
  recreateHamtLevel: recreateHamtLevel,
  addLinksToHamtBucket: addLinksToHamtBucket,
  toPrefix: toPrefix,
  createShard: createShard
};